// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Element from 'element-ui';
import App from './App';
import router from './router';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import Main from '@/common/plugin/message/main';

window.Promise = Promise;

Vue.use(Element, { size: 'small', zIndex: 3000 });
Vue.config.productionTip = false;

// ·��ǰ������
router.beforeEach((to, from, next) => {
  if (to.path === '/Login' || to.path === '/forget') {
    next();
  } else {
    if (!sessionStorage.getItem('userId')) {
      next({ path: '/Login' });
    } else {
      next();
    }
  }
});

Vue.use(Main);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js